export default "__VITE_ASSET__Dt8ZaAE6__"